"use client";

import React, { type PropsWithChildren } from "react";

import AdapterLinkButton from "@/components/Adapter/LinkButton";
import { SupHeading, SupText } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";
import { SupChevronLeft } from "@repo/core-ui";

type SupErrorProps = PropsWithChildren<{
  errorTitle?: string;
  errorDescription?: string;
  errorCode?: number;
  isRed?: boolean;
  className?: string;
  showBackLink?: boolean;
  backLink?: string;
  backLinkText?: string;
  fixedHeight?: boolean;
}>;

export default function UiMessageError({
  children,
  errorTitle = undefined,
  errorDescription = undefined,
  errorCode = undefined,
  isRed = false,
  fixedHeight = true,
  showBackLink = false,
  backLink = "/",
  backLinkText = "Back to Explore",
  className = undefined,
}: SupErrorProps) {
  return (
    <div className={twMerge("mx-auto w-fit max-w-xl", fixedHeight && "h-[500px] space-y-2 py-16 text-center sm:py-24", className)}>
      {errorCode && (
        <SupText variant="subtitle1" className="text-error-700" weight="bold">
          {errorCode} error
        </SupText>
      )}
      {errorTitle && (
        <SupHeading variant="h2" as="h1" weight="bold" color={isRed ? "error" : "primary"}>
          {errorTitle}
        </SupHeading>
      )}
      {errorDescription && <SupText variant="caption">{errorDescription}</SupText>}
      {children}
      {showBackLink && (
        <AdapterLinkButton
          className="mt-5 w-fit self-center p-2 hover:bg-primary-75 md:inline-flex"
          buttonProps={{
            variant: "outlined",
            prefixIcon: backLink.startsWith("http") ? undefined : <SupChevronLeft />,
          }}
          href={backLink}
          target={backLink.startsWith("http") ? "_blank" : undefined}
        >
          {backLinkText}
        </AdapterLinkButton>
      )}
    </div>
  );
}
